import { gql } from "@apollo/client";

// Post-site-creation "waiting on the customer" answer (postSiteKeyCheckModal.jsx) - registers an
// expected key receipt without any of the real-key fields newKeyMutation requires.
export const createPendingKeyReceiptMutation = gql`
mutation($input: CreatePendingKeyReceiptInput!){
  createPendingKeyReceipt(input: $input) {
    message
    response
  }
}
`;

// Site-list alert (site.page.jsx) - every site still waiting on its key.
export const getSitesAwaitingKeyReceiptQuery = gql`
query{
  getSitesAwaitingKeyReceipt {
    message
    response
  }
}
`;

export const newKeyGroupMutation = gql`
mutation($input: KeyGroupInput!){
  newKeyGroup(input: $input) {
    message
  }
}
`;


export const updateKeyGroupMutation = gql`
mutation($input: KeyGroupInput!){
  updateKeyGroup(input: $input) {
    message
  }
}
`;

export const assignKeyGroupMutation = gql`
mutation($input: KeyGroupAssignInput!){
  assignKeyGroup(input: $input) {
    message
  }
}
`;


export const lostKeyGroupMutation = gql`
mutation($input: KeyGroupReportLostInput!){
  lostKeyGroup(input: $input) {
    message
  }
}`;

export const requestReturnKeyGroupMutation = gql`
mutation($input: KeyGroupReturnInput!){
  RequestReturnKeyGroup(input: $input) {
    message
  }
}
`;

export const returnKeyGroupMutation = gql`
mutation($input: keygroupReturnedInput!){
  returnKeyGroup(input: $input) {
    message
  }
}`;


export const markAsFoundKeyGroupMutation = gql`
mutation($input: keygroupFoundInput!){
  markAsFoundKeyGroup(input: $input) {
    message
  }
}
`;


export const DELETE_KEY_GROUP_Mutation = gql`
  mutation DeleteKeyGroup($keyGroupId: String!) {
    deleteKeyGroup(keyGroupId: $keyGroupId) {
      message
    }
  }
`;


// ================================================================================
    // =================================================== Key Mutation
// ================================================================================


export const newKeyMutation = gql`
mutation($input: AllKeysInput!){
  newKey(input: $input) {
    message
  }
}
`;

export const updateKeyMutation = gql`
mutation($input: AllKeysInput!, $updateKeyId: String!){
  updateKey(input: $input, id: $updateKeyId) {
    message
  }
}
`;

export const deleteKeyMutation = gql`
mutation($deleteKeyId: String!){
  deleteKey(id: $deleteKeyId) {
    message
  }
}
`;


export const assignKeyMutation = gql`
mutation($input: KeyAssignInput!){
  assignKey(input: $input) {
    message
  }
}
`;


export const requestReturnKeyMutation = gql`
mutation($input: KeyReturnInput!){
  RequestReturnKey(input: $input) {
    message
  }
}
`;

export const returnKeyMutation = gql`
mutation($input: keyReturnedInput!){
  returnKey(input: $input) {
    message
  }
}
`;

export const lostKeyMutation = gql`
mutation($input: KeyReportLostInput!){
  lostKey(input: $input) {
    message
  }
}
`;

export const markasFoundKeyMutation = gql`
  mutation($input: keyFoundInput!){
    markAsFoundKey(input: $input) {
      message
    }
  }
`;


export const returnKeyToCustomerMutation = gql`
mutation($input: returnToCustomer!){
  returnKeyToCustomer(input: $input) {
    message
  }
}
`;


export const moveKeyToGroupMutation = gql`
mutation($groupId: String!, $keyId: String!){
  moveKeyToGroup(groupId: $groupId, keyId: $keyId) {
    message
  }
}
`;


export const addKeyToGroupMutation = gql`
mutation($groupId: String!, $keyId: String!){
  assignKeyToGroup(groupId: $groupId, keyId: $keyId) {
    message
  }
}
`;

export const makeAuditRequestMutation = gql`
  mutation($input: AuditRequestInput!){
    makeAduitRequest(input: $input) {
      message
    }
  }
`;

export const submitKeyAuditResultMutation = gql`
  mutation($input: KeyAuditResultInput!){
    newKeyAuditResult(input: $input) {
      message
    }
  }
`;


export const SET_KEY_AUDIT_REQUEST_EXPIRE_Mutation = gql`
  mutation SetKeyAuditRequestToExpire($auditRequestId: String!) {
    setKeyAuditRequestToExpire(auditRequestId: $auditRequestId) {
      message
      response
    }
  }
`;

export const replaceKeyUnitMutation = gql`
  mutation($input: ReplaceKeyUnitInput!){
    replaceKeyUnit(input: $input) {
      message
    }
  }
`;

export const reportKeyDamagedMutation = gql`
  mutation($input: ReportKeyDamagedInput!){
    reportKeyDamaged(input: $input) {
      message
    }
  }
`;